import React, { PureComponent } from 'react'
import {
  func, bool, string, shape,
} from 'prop-types'
import Modal from '@active/react-ui/Modal'
import ModalBody from '@active/react-ui/ModalBody'
import ModalFooter from '@active/react-ui/ModalFooter'
import Button from '@active/react-ui/Button'
import ReviewProfileContent from '../../../IdentityProvider/ReviewProfileContent'
import I18nMessage from '../../../common/I18nMessage'

class ReviewProfileModal extends PureComponent {
  static propTypes = {
    handleReviewProfileSubmit: func.isRequired,
    handleReviewProfileModalClose: func.isRequired,

    configureTrack: func.isRequired,
    clientConfig: shape({
      suppressActiveWaiver: bool,
      useCustomizeWaiver: bool,
      waiverAttachementObjectIds: string,
    }).isRequired,
  }

  submitForm

  componentDidMount() {
    const { configureTrack } = this.props
    configureTrack({
      eventName: 'ReviewProfileModal init',
      widget: 'ReviewProfileModal',
      pageType: 'ReviewProfileModal',
    })
  }

  submitFormTriggerBuilder = submitForm => {
    this.submitForm = submitForm
  }

  handleClick = () => {
    this.submitForm()
  }

  render() {
    const { handleReviewProfileModalClose, ...rest } = this.props
    return (
      <Modal
        size="md"
        autoFocusClose
        shown
        onClose={handleReviewProfileModalClose}
        className="passport-ui-app__modal passport-review_profile_modal"
        title={<I18nMessage id="passport.review.profile.title" />}
      >
        <ModalBody>
          <ReviewProfileContent
            {...rest}
            hasSubmitButton={false}
            submitFormTriggerBuilder={this.submitFormTriggerBuilder}
          />
        </ModalBody>
        <ModalFooter>
          <div className="passport-content-footer">
            <Button type="super" onClick={this.handleClick}>
              <I18nMessage id="passport.common.btn.signUp" />
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    )
  }
}

export default ReviewProfileModal
